import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { isMobile, isMobileXL } from 'src/app/shared/utils/helpers';
import { ConfigService } from '../shared/services/config.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import {MatRadioModule} from '@angular/material/radio';
import { CotizacionesService } from 'src/app/shared/services/cotizaciones.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { CotizacionCabecera } from 'src/app/shared/models/cotizacionCabecera';

@Component({
  selector: 'app-confirmacion-cotizacion',
  templateUrl: './confirmacion-cotizacion.component.html',
  styleUrls: ['./confirmacion-cotizacion.component.scss'],
})
export class ConfirmacionCotizacionComponent {

  rutaActual: string;
  form: FormGroup;
  isAccepting: boolean = false; // Default to rejection
  estados: string[] = ['Aprobada', 'Rechazada'];
  favoriteSeason: string;
  aprobar: number;
  token: string;
  mostrarFormulario: boolean = true;
  mensajeAgradecimiento: string = '';
  nroPedido: string = '';
  tokenValido: boolean;
  public Etiquetas: {

    Ayuda: string;
    CambiarClave: string;
    CerrarSesion: string;
    IconoADM: string;
    IconoPedidos:string,
    IconoCuentas: string;
    IconoProductos: string;
    IconoTablas: string;
    LeyendaContacto: string
    MailContacto: string
    TituloApp: string
    TituloCerrarMenu: string
    ConfirmacionCotizacion:{
      Titulo:string,
      Path:string
    },
    Home: {
      Titulo: string
      Path: string
    },
    Usuarios: {
      Titulo: string
      Path: string
      ConfirmarEmail: {
        Titulo: string
        Path: string
      }
    }

  }
  constructor(
    private router: Router,
    private configService: ConfigService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private cotizacionesService: CotizacionesService,
    private snackBarService: SnackbarService,
  ) {
    this.form = this.formBuilder.group({
      opcionSeleccionada: ['', Validators.required],
      comentarioLogAutorizacion: ['', [Validators.maxLength(4000)]]
    });
  }

  ngOnInit() {
    this.rutaActual = this.router.url;
    this.Etiquetas = {
      Ayuda: this.configService.etiquetas.Login.Ayuda,
      CambiarClave: this.configService.etiquetas.MenuUsuario.CambiarClave,
      CerrarSesion: this.configService.etiquetas.MenuUsuario.CerrarSesion,
      IconoADM: this.configService.etiquetas.IconoADM,
      IconoPedidos: this.configService.etiquetas.IconoPedidos,
      IconoCuentas: this.configService.etiquetas.IconoCuentas,
      IconoProductos: this.configService.etiquetas.IconoProductos,
      IconoTablas: this.configService.etiquetas.IconoTablas,
      LeyendaContacto: this.configService.etiquetas.LeyendaContacto,
      MailContacto: this.configService.etiquetas.MailContacto,
      TituloApp: this.configService.etiquetas.TituloApp,
      TituloCerrarMenu: this.configService.etiquetas.TituloCerrarMenu,
      ConfirmacionCotizacion: {
        Titulo: this.configService.etiquetas.ConfirmacionCotizacion.Titulo,
        Path: this.configService.etiquetas.ConfirmacionCotizacion.Path
      },
      Home: {
        Titulo: this.configService.etiquetas.Home.Titulo,
        Path: this.configService.etiquetas.Home.Path
      },
      Usuarios: {
        Titulo: this.configService.etiquetas.Usuarios.Titulo,
        Path: this.configService.etiquetas.Usuarios.Path,
        ConfirmarEmail: {
          Titulo: this.configService.etiquetas.ConfirmarEmail.Titulo,
          Path: this.configService.etiquetas.ConfirmarEmail.Path
        }
      },
    };
    this.activatedRoute.queryParams.subscribe(params => {
      this.aprobar = parseInt(params['aprobar']);
      this.token = params['t'];
      this.validarToken();
      this.nroPedido= params['nropedido'];
      // Si el valor de 'aprobar' es 1, establece '1' como opción seleccionada, de lo contrario establece '0'
      const opcionSeleccionada = this.aprobar === 1 ? '1' : '0';

      this.form = this.formBuilder.group({
        opcionSeleccionada: [opcionSeleccionada, Validators.required]
      });
    });
  }

  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }
  
  validarToken():void{
    this.cotizacionesService.validarToken(this.token).subscribe((data: boolean)=>
      {
        this.tokenValido = data;
        if(!this.tokenValido)
        {
          this.mostrarFormulario = false;
          this.mensajeAgradecimiento = 'TOKEN INVALIDO!';
          this.snackBarService.openSnackbar("Error!","Token Invalido!",0,2);
        }
      });


  }

  onSubmit() 
  {

    const opcionSeleccionada = this.form.value.opcionSeleccionada;
    if(this.tokenValido)
    {
      if(opcionSeleccionada == 1)
      {

        this.cotizacionesService.procesarCotizacion(this.nroPedido).subscribe((data: CotizacionCabecera) => {
          if (data != null) {
            this.mostrarFormulario = false;
            this.mensajeAgradecimiento = 'Muchas gracias, la cotización acaba de quedar Aprobada.';
    
            this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.AprobacionPedidoExitosa, 1, 2);
          }
        }, error => {
          this.mostrarFormulario = true;
          this.mensajeAgradecimiento = "";
          this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, error.error, 0, 2);

          console.error('Error al enviar la solicitud:', error.error);
      });
      }
      else
      {
        this.cotizacionesService.rechazarCotizacion(this.form.value).subscribe((data: CotizacionCabecera) => {
          if (data != null) 
          {  
            this.mostrarFormulario = false;
            this.mensajeAgradecimiento = 'Muchas gracias, la cotización acaba de quedar Rechazada.';
            this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.RechazoPedidoExitoso, 1, 2);
          }
        }, error => {
          this.mostrarFormulario = true;
          this.mensajeAgradecimiento = "";
          this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, error.error, 0, 2);
          console.error('Error al enviar la solicitud:', error.error);
      });
      }
      this.form.value.mostrarFormulario = this.mostrarFormulario;
      this.form.value.mensajeAgradecimiento = this.mensajeAgradecimiento;
    }
    else
    {
      this.mostrarFormulario = false;
      this.mensajeAgradecimiento = 'TOKEN INVALIDO!';
      this.snackBarService.openSnackbar("Error!","Token Invalido!",0,3);
    }

    // Handle success or error scenarios
  }
}
